import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IAuthController} from "views/controllers/auth/auth.controller";
import {ModalType} from "data/enums";
import {getPickEmLogo} from "data/utils";
import type {ICouponStore} from "data/stores/coupon/coupon.store";
import type {IModalsStore} from "data/stores/modals/modals.store";
import {createFanHubEvent} from "data/utils/helpers";

interface IProps {
	language: string;
}

export interface ISubHeaderController extends ViewController<IProps> {
	get isAuthorized(): boolean;
	get logo(): string;
	get isShowCoupon(): boolean;

	showCoupon: () => void;
	trackRegEvent: () => void;
	trackLoginEvent: () => void;
	trackSponsorEvent: () => void;
	trackNavEvent: (guid?: string) => void;
}

@injectable()
export class SubHeaderController implements ISubHeaderController {
	@observable private _isOpenProjectsLinks = false;
	@observable private _language = "en";

	get isAuthorized() {
		return this._authController.isAuthorized;
	}

	get logo() {
		return getPickEmLogo(this._language);
	}

	get coupon() {
		return this._couponStore.firstPickSubmissionCoupon;
	}

	get isShowCoupon() {
		return this.isAuthorized && Boolean(this.coupon);
	}

	constructor(
		@inject(Bindings.AuthController) private _authController: IAuthController,
		@inject(Bindings.CouponStore) private _couponStore: ICouponStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	showCoupon = () => {
		this._modalsStore.showModal(ModalType.COUPON, this.coupon);
	};

	init(param: IProps) {
		this._language = param.language;
	}

	trackRegEvent = () => {
		this._authController.trackRegEvent();
	};

	trackLoginEvent = () => {
		this._authController.trackLoginEvent();
	};

	trackSponsorEvent = () => {
		createFanHubEvent("a9400e1f-0b7a-404f-beff-8f1ac96fcc86");
	};

	trackNavEvent = (guid?: string) => {
		if (guid) {
			createFanHubEvent(guid);
		}
	};

	dispose() {
		return;
	}
}
